import { UserRoleEnum } from '@constant';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILoginResponse, IStoreAuth } from '@types';

const initialState: IStoreAuth = {
  isLogin: false,
  name: '',
  email: '',
  role: UserRoleEnum['일반 회원']
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<ILoginResponse>) => {
      sessionStorage.setItem('accessToken', action.payload.token.accessToken);
      sessionStorage.setItem('refreshToken', action.payload.token.refreshToken);

      return {
        isLogin: true,
        name: action.payload.user.name,
        email: action.payload.user.email,
        role: action.payload.user.role
      };
    },

    logout: () => {
      sessionStorage.clear();
      return initialState;
    }
  }
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
